import { AxiosError } from "axios";
import { AnyAction, Dispatch } from "@reduxjs/toolkit";

import { rxErrorFetchingData, rxSuccessFetchingData, rxStartFetching } from "./myTickets.slice";
import { axiosApiService } from "../../services/axiosApi.service";
import { MyPendingTicketsFilterRequest, MyTicketsFilterRequest } from "../../../types/request/ticket.request.type";
import { HelpDeskApiRoutes } from "../../../utils/mapping/apiRoutes.mapping";
import { Ticket } from "../../../types/models/ticket.model.type";

export const getMyTickets = (params: MyTicketsFilterRequest) => async (dispatch: Dispatch<AnyAction>) => {
  try {
    dispatch(rxStartFetching());
    const { data } = await axiosApiService().get(HelpDeskApiRoutes.myTickets, { params: params });
    if (params.status) {
      const dataFiltered = data.filter((m: Ticket) => m.idEstado === params.status);
      dispatch(rxSuccessFetchingData(dataFiltered));
    } else {
      dispatch(rxSuccessFetchingData(data));
    }
  } catch (error) {
    const err = error as AxiosError;
    dispatch(rxErrorFetchingData(err.message));
  }
};

export const getMyPendingTickets = (params: MyPendingTicketsFilterRequest) => async (dispatch: Dispatch<AnyAction>) => {
  try {
    dispatch(rxStartFetching());
    const { data } = await axiosApiService().get(HelpDeskApiRoutes.myPendingTickets, { params: params });
    dispatch(rxSuccessFetchingData(data));
  } catch (error) {
    const err = error as AxiosError;
    dispatch(rxErrorFetchingData(err.message));
  }
};
